
import { MapLocation } from '@/types/location';

// Above & Beyond Gym Locations
export const aboveAndBeyondGyms: MapLocation[] = [
  {
    id: 20001,
    name: "Above & Beyond Gym - Riyadh (King Faisal)",
    type: "Gym",
    devices: 3,
    coordinates: [24.77362412956103, 46.766038673826806],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-40",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
